import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { BrandingWorkspace } from "./modules/branding/BrandingWorkspace.tsx";

const router = createBrowserRouter([{ path: "*", element: <BrandingWorkspace /> }]);

export function App() {
  return <RouterProvider router={router} />;
}
